<script>
  export let value;
  export let onClick;
  export let icon = undefined;
</script>

<div class='admin-action' on:click|preventDefault={onClick}>
  <div class='admin-action-box'>
    <div class='admin-action-box-text'>
      {#if icon} <span class='material-icons'> {icon} </span> {/if} {value}
    </div>
  </div>
</div>

<style>
  .admin-action {
    background: var(--white);

    font-family: 'JetBrains Mono';
    font-weight: bold;

    cursor: pointer;
    user-select: none;
  }

  .admin-action-box {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    padding: 5px;

    transition: background-color 0.25s ease-in-out;
  }

  .admin-action:hover .admin-action-box {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .admin-action:active .admin-action-box {
    background-color: rgba(0, 0, 0, 0.2);
  }

  :global(body.dark) .admin-action {
    background: var(--grey-3);
    color: var(--black);
  }
</style>
